import { Link } from "react-router-dom";
import useIsMobile from "../../../hooks/useIsMobile";
import "./site-footer-style.css";

//全站共用 footer（web + mobile），以 library-center 的 footer 為標準
//  預設自己偵測 isMobile（window 寬度 <= 768）；也可由外部傳 isMobile 覆寫
//  公司資訊 / 連結 / copyright 統一在此維護，之後改 footer 只改這一支
const SiteFooter = ({ isMobile: isMobileProp }) => {
  const autoMobile = useIsMobile();

  const isMobile = isMobileProp !== undefined ? isMobileProp : autoMobile;

  const Logo = (
    <div className="sf-logo">
      <img src="/images/ic-yuanchen-logo.png" loading="lazy" alt="元辰雲閣" />
    </div>
  );
  const links = (
    <div className="sf-links">
      <Link to="/policy">隱私權政策與使用條款</Link>
      <a
        href="https://lin.ee/nDspmFB"
        target="_blank"
        rel="noopener noreferrer"
      >
        聯絡官方Line客服
      </a>
    </div>
  );

  if (isMobile) {
    return (
      <footer className="site-footer site-footer--mobile">
        {Logo}
        {links}
        <div className="sf-company">
          <span>萊諾創新科技有限公司</span>
          <span>yuanchencloud@gmail.com</span>
        </div>
        <p className="sf-copyright">Copyright © 2026 元辰雲閣</p>
      </footer>
    );
  }

  return (
    <footer className="site-footer site-footer--web">
      <div className="sf-inner">
        {Logo}
        <div className="sf-info">
          {links}
          <div className="sf-company">
            <span>萊諾創新科技有限公司</span>
            <span>yuanchencloud@gmail.com</span>
            <span>Copyright © 2026 元辰雲閣</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
